import type { InternalDropdownOption } from '~/components/DropdownTreeSingleSelect/types';
import { TerritoryLabel } from '~/components/TerritoryLabel/TerritoryLabel';

function MarketOptionTemplate({ option }: { option: InternalDropdownOption }) {
  return (
    <TerritoryLabel
      code={option.value}
      flagClassName="size-[16px]"
      textClassName="truncate"
    />
  );
}

MarketOptionTemplate.displayName = 'MarketOptionTemplate';

export { MarketOptionTemplate };
